export default __webpack_public_path__ + "static/media/ETH-BNB.cc89b95d.png";